export class EvaluateServiceTransactionErrorResponse {
  destinationEvaluation: any;
  sourceEvaluation: any;
  'transaction.transactionId': any;
}
